/* 
 * Javascript object of dd_home_controllerZone
 */

var dd_home_controllerZoneObject;
var dd_home_controllerZone = function(){
    this.scrollCurrent=null;
    
    this.iWindowsSize;
    this.mzr_a=50;
    this.mzr_b=111; 
  

    this.ts1;
    this.ts1OffsetY;	

    this.ts2;
    this.ts2OffsetY;	

    this.ts3;
    this.ts3OffsetY;	
  

    

  
    this.ts8;
    this.ts8OffsetY;	

};

        

/**
 * All the things that should be done at the begining of this script
 * @returns {undefined}
 */
dd_home_controllerZone.prototype.init = function(){
    var thisObject = this;
    
    this.iWindowsSize = jQuery(window).width();

  
    this.ts1 = document.querySelector('#ts1');
    this.ts1OffsetY = this.ts1.offsetTop;	
  
    this.ts2 = document.querySelector('#ts2');
    this.ts2OffsetY = this.ts2.offsetTop;	

    this.ts3 = document.querySelector('#ts3');
    this.ts3OffsetY = this.ts3.offsetTop;	

    this.ts4 = document.querySelector('#dd-video');
    this.ts4OffsetY = this.ts4.offsetTop;	
  

  
    this.ts8 = document.querySelector('#zn_gotosolution_wrp');
    this.ts8OffsetY = this.ts8.offsetTop;	  
  
  
    this.ts10 = document.querySelector('#zn_prodline');
    this.ts10OffsetY = this.ts10.offsetTop;	  
  
  
  
  
    if (this.iWindowsSize  > 768 ){
        jQuery(document).scroll(function(){
            thisObject.scroll();
        });
        
        mzr_1=111;
        mzr_2=161;

        this.scroll();
      

    }
  
  	  
};
var controlUpdateValue = false;
dd_home_controllerZone.prototype.scroll = function(){
   var thisObject = this;
    

    // ------ ControllerZone ---------- //
  
    if(jQuery(window).scrollTop() + this.mzr_a   < this.ts1OffsetY){
        // ------ 0 ------ 
        if(this.scrollCurrent !== "0"){
            this.scrollCurrent = "0";
			
          	


            jQuery('#zn_cllrbg').addClass('bkg0');
            jQuery('#zn_cllrbg').removeClass('bkg1').removeClass('bkg2').removeClass('bkg3');

            //jQuery('#zn_cllr_wrp').addClass('bkg0');
            //jQuery('#zn_cllr_wrp').removeClass('bkgcl1').removeClass('bkgcl2').removeClass('bkgcl3');

            jQuery("#ts-mnu1").removeClass('sty_opcty'); //apparait texte
            jQuery("#ts-mnu2").addClass('sty_opcty');//disparait texte
            jQuery("#ts-mnu3").addClass('sty_opcty');//disparait texte
          
            jQuery("#ts-mnu1").addClass('sty_zindx'); //mettre en premier plan
          	

          	// NEW  //
              jQuery('.zn_txtcllr').removeClass('dd_sticky');
              jQuery('#ts-mnu1').removeClass('dd_stickymargin');
            // NEW END //
          
          	jQuery(".txtlink-how").removeClass('sty_opcty1');//disparait texte
            
          	jQuery(".zn_bgtxtcllr_wrp").css("position","absolute");
            jQuery(".zn_bgtxtcllr_wrp").css("top","inherit");
          
        }

    }else if(jQuery(window).scrollTop() < this.ts2OffsetY ){
        // ------ I ------ 
        if(this.scrollCurrent !== "1"){
            this.scrollCurrent = "1";
          
            // NEW  //
              jQuery('.zn_txtcllr').addClass('dd_sticky');
              jQuery('#ts-mnu1').addClass('dd_stickymargin');
            // NEW END //

            //Rem
            jQuery('#zn_cllrbg').removeClass('bkg2').removeClass('bkg3');
            //jQuery('#zn_cllr_wrp').removeClass('bkgcl2').removeClass('bkgcl3');
            jQuery("#ts-mnu2, #ts-mnu3").addClass('sty_opcty');//disparait texte

            //Add
            jQuery('#zn_cllrbg').addClass('bkg1');

            //jQuery('#zn_cllr_wrp').addClass('bkgcl1').removeClass('bkgcl1');
            setTimeout(function(){
                if(thisObject.scrollCurrent == "1"){
                	jQuery("#ts-mnu1").removeClass('sty_opcty'); //apparait texte
                  
                    jQuery("#ts-mnu1").addClass('sty_zindx'); //mettre en premier plan
                }
            },0);
          
          	jQuery(".txtlink-how").addClass('sty_opcty1'); //apparait texte
          	jQuery(".txtlink-how").addClass('sty_zindx'); //apparait texte
          
          	jQuery(".zn_bgtxtcllr_wrp").css("position","fixed");
            jQuery(".zn_bgtxtcllr_wrp").css("top","110px");
          
        }
    }else if(jQuery(window).scrollTop() + this.mzr_b < this.ts3OffsetY){
        // ------ II ------ 
        if(this.scrollCurrent !== "2"){
            this.scrollCurrent = "2";

            //Rem
            jQuery('#zn_cllrbg').removeClass('bkg1').removeClass('bkg3');
            //jQuery('#zn_cllr_wrp').removeClass('bkgcl1').removeClass('bkgcl3');
            jQuery("#ts-mnu1, #ts-mnu3").addClass('sty_opcty');


            //Add
            jQuery('#zn_cllrbg').addClass('bkg2');
            //jQuery('#zn_cllr_wrp').addClass('bkgcl2');
            setTimeout(function(){
              if(thisObject.scrollCurrent == "2"){
                jQuery("#ts-mnu2").removeClass('sty_opcty');
                
                jQuery("#ts-mnu2").addClass('sty_zindx'); //mettre en premier plan
              }
            },0);
          
          console.log(this.scrollCurrent);

        }
    }else{
        // ------ III ------ 
        if(this.scrollCurrent !== "3"){
            this.scrollCurrent = "3";

            //Rem
            jQuery('#zn_cllrbg').removeClass('bkg1').removeClass('bkg2');
            //jQuery('#zn_cllr_wrp').removeClass('bkgcl1').removeClass('bkgcl2');
            jQuery("#ts-mnu1, #ts-mnu2").addClass('sty_opcty');

            //Add
            jQuery('#zn_cllrbg').addClass('bkg3');
            jQuery('#zn_cllr_wrp').addClass('bkgcl3');
            setTimeout(function(){
              if(thisObject.scrollCurrent == "3"){
                jQuery("#ts-mnu3").removeClass('sty_opcty');
                
                jQuery("#ts-mnu3").addClass('sty_zindx'); //mettre en premier plan
              }
            },0);
          
          console.log(this.scrollCurrent);
            
			//jQuery(".zn_cllr_wrp ").unstick();
          
          
        }
    }

    /* EFFACER BANDE CllrZone */ 
  
      if (jQuery(window).scrollTop() + 500 >= this.ts10OffsetY) {
            jQuery(".zn_txtcllr").fadeOut(200);
        
         	jQuery(".zn_bgtxtcllr_wrp").fadeOut(400);
       

      } else {
              //jQuery("#new-lf-wrp").removeClass('sty_dspnn');
              jQuery(".zn_txtcllr").fadeIn();
        
        	jQuery(".zn_bgtxtcllr_wrp").fadeIn();
      } 

  
  	// ------ VI ------  (ZONE GoToSolution_wrp)
	
      if (jQuery(window).scrollTop() + 0 >= this.ts8OffsetY) {
        
               jQuery(".gtsolution1").addClass("load");
              
        	  setTimeout(function(){
                   jQuery(".gtsolution2").addClass("load");
              },  150);

          	  setTimeout(function(){
                  jQuery(".gtsolution3").addClass("load");
              },  300);
        
        	  setTimeout(function(){
                   jQuery(".gtsolution4").addClass("load");
              },  450);

          	  setTimeout(function(){
                  jQuery(".gtsolution5").addClass("load");
              },  600);
        
        	  setTimeout(function(){
                  jQuery(".gtsolution5").addClass("load");
              },  750);
        
               
        
      }     

  
  
  
  
	// --- End --
};





//Declare the dd_home_controllerZone object
dd_home_controllerZoneObject = new dd_home_controllerZone();

//Initiate the events (buttons ...)
jQuery(document).ready(function(e) {
    dd_home_controllerZoneObject.init();
});

